module.exports = __webpack_public_path__ + "img/zsgg-5.87eb0056.png";